import { getLocalStorageData, storeLocalStorageData } from "@picovico/utils";

export const setTenantDomain = (domain: string) => {
  storeLocalStorageData("tDom", domain);
};

export const getTenantDomain = (): string | null => {
  return getLocalStorageData("tDom");
};
